import { Component, OnInit } from '@angular/core';
import { GastroPayService } from '@app/gastro-pay/gastro-pay.service';
import { ClientResolverService } from '@app/core/client-resolver.service';
import { CredentialsService } from '@app/core/authentication/credentials.service';
import { environment } from '@env/environment';

import * as jspdf from 'jspdf';
import 'jspdf-autotable';
import html2canvas from 'html2canvas';

import moment from 'moment';
import { AccountingService } from '@app/accounting/accounting.service';
moment.locale('de');

@Component({
  selector: 'app-invoice-list',
  templateUrl: './invoice-list.component.html',
  styleUrls: ['./invoice-list.component.scss']
})
export class InvoiceListComponent implements OnInit {
  invoices: any[] = [];
  private scriptElement: HTMLScriptElement | null = null;

  constructor(private accountingService: AccountingService) {}

  ngOnInit() {
    this.ngOnInitRevolutListener();
    this.getInvoices();
    // this.loadRevolutScript();
  }

  ngAfterViewInit() {
    this.loadRevolutScript();
  }

  ngOnDestroy() {
    this.removeRevolutScript();
  }

  getInvoices() {
    this.accountingService.getInvoices().subscribe((data: any) => {
      this.invoices = data || [];
    });
  }

  private loadRevolutScript() {
    this.scriptElement = document.createElement('script');
    this.scriptElement.src =
      environment.revolutPayUrl + 'payment/revolut-payment.js?selectors=.payButton,.custom-pay-button';

    console.log(27, 'script created', this.scriptElement);
    // <script src="https://localhost:4000/revolut-payment.js?selectors=.payButton,.custom-pay-button" />
    this.scriptElement.async = true;
    this.scriptElement.defer = true;
    document.body.appendChild(this.scriptElement);
  }

  private removeRevolutScript() {
    console.log(27, 'script removed');
    if (this.scriptElement) {
      document.body.removeChild(this.scriptElement);
      this.scriptElement = null;
    }
  }

  returnPrice(price: any) {
    if (typeof price == 'string') {
      return parseFloat(price.replace(',', '.'));
    } else {
      return price || 0;
    }
  }
  translateMethod(text: string) {
    // 'moneyTransfer','lastschrift','onlinePayment','Storno','rechnung','kreditkarte','sofortüberweisung','paypal','teilstorno','verrechnung'
    return text
      .replace('verrechnung', 'Verrechnet am')
      .replace('moneyTransfer', 'Überweisung am')
      .replace('lastschrift', 'Lastschrift am')
      .replace('Storno', 'Storniert am')
      .replace('rechnung', 'Auf Rechnung')
      .replace('kreditkarte', 'Kreditkarte am')
      .replace('sofortüberweisung', 'Sofortüberweisung am')
      .replace('paypal', 'PayPal am')
      .replace('teilstorno', 'Teilweise storniert');
  }

  ngOnInitRevolutListener() {
    window.addEventListener('revolutPaymentEvent', (event: any) => {
      if (!event || !event.detail) {
        console.error('Revolut payment event detail is missing:', event);
      }
      if (event.detail.status === 'success' && event.detail.data && event.detail.data.id) {
        // this.createVoucherOrder(event.detail.data.id);
        console.log(811, 'Revolut Payment Success:', event.detail);
        this.accountingService.updateInvoiceAfterPayment(event.detail.data).subscribe((data: any) => {
          this.getInvoices();
          console.log(96, 'Update Invoice After Payment:', data);
        });
      } else if (event.detail.status === 'error') {
        alert(
          'Es gab einen Fehler bei der Zahlung.\n\nBitte versuchen Sie es erneut oder probieren Sie eine andere Zahlungsart aus.'
        );
      } else if (event.detail.status === 'cancel') {
        alert(
          'Der Zahlvorgang wurde abgebrochen.\n\nBitte versuchen Sie es erneut oder probieren Sie eine andere Zahlungsart aus.'
        );
      }
      console.log(811, 'Revolut Payment Event:', event);
    });
  }
}
